import axios from "axios";
import { ApiUrl } from "../../../utils/Network";

// import { EnvConfig } from "../../../constants/EnvConfig";

// const BARRACKS_URL = EnvConfig?.API_URL + "/api/v1";

export const getPlayerTroop = (count: number = 50) => {
  return axios.get(`${ApiUrl}/playertroop?count=${count}`);
};

export const getBarracksBuildingInfo = () => {
  return axios.get(`${ApiUrl}/building/info/6`);
};

export const getterGetMe = () => {
  return axios.get(`${ApiUrl}/player`);
};

export const getTroopLevels = () => {
  return axios.get(`${ApiUrl}/troop/levels`);
};

export const trainRequestPlayerTroop = ({troopId}: { troopId: number }) => {
  return axios.post(`${ApiUrl}/playertroop/train`, { troopId });
};
